import styled from 'styled-components';
import { THUNDERDOME } from 'HubStyleTokens/colors';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIButtonWrapper from 'UIComponents/layout/UIButtonWrapper';
import UILink from 'UIComponents/link/UILink';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledAIInfoIcon = styled(UIIcon).withConfig({
  displayName: "AIAssistantOnboardingPopover__StyledAIInfoIcon",
  componentId: "sc-142t55f-0"
})(["position:absolute;top:-27px;left:-9px;cursor:pointer;"]);
export const AIAssistantOnboardingPopover = props => {
  const {
    aiInfoIconOpen,
    setAiInfoIconOpen,
    setHasSeenAIOnboardingPopover,
    settingsUrl
  } = props;
  return /*#__PURE__*/_jsx(UIPopover, {
    "data-test-id": "ai-assistant-ai-onboarding-popover",
    use: "shepherd",
    open: aiInfoIconOpen,
    showCloseButton: true,
    onOpenChange: evt => {
      setAiInfoIconOpen(evt.target.value);
      setHasSeenAIOnboardingPopover();
    },
    width: 350,
    content: {
      header: /*#__PURE__*/_jsx("h4", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: 'hubspot-prosemirror.onboardingPopover.header'
        })
      }),
      body: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "hubspot-prosemirror.onboardingPopover.body_jsx",
        elements: {
          Link: UILink
        },
        options: {
          href: settingsUrl,
          external: true
        }
      }),
      footer: /*#__PURE__*/_jsx(UIButtonWrapper, {
        justify: "end",
        children: /*#__PURE__*/_jsx(UIButton, {
          use: "primary",
          onClick: setHasSeenAIOnboardingPopover,
          size: "small",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'hubspot-prosemirror.onboardingPopover.button'
          })
        })
      })
    },
    children: /*#__PURE__*/_jsx(StyledAIInfoIcon, {
      "data-test-id": "ai-assistant-ai-info-icon",
      name: "info",
      size: 32,
      color: THUNDERDOME,
      onClick: () => setAiInfoIconOpen(!aiInfoIconOpen)
    })
  });
};